/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description insurance constants
 */

import { MONTH_DATE_YEAR_SLASH_FORMAT } from '@veritable/common/constants';

const FIELDS_META = {
	responsibilitySequence: {
		title: 'Insurance Responsibility Sequence',
		placeholder: 'E.g.: Primary',
	},
	payer: {
		title: 'Payer Name',
		placeholder: 'E.g.: Cigna',
		errorMessage: 'Payer Name is required',
	},
	memberId: {
		title: 'Member ID',
		placeholder: 'E.g.: WXI234FJCHI',
		errorMessage: 'Member ID is required',
	},
	insuranceType: {
		title: 'Insurance Type',
		placeholder: 'Select Insurance Type',
	},
	subscriberName: {
		title: 'Subscriber Name',
		placeholder: 'E.g.: John Doe',
		errorMessage: 'Subscriber name is required',
	},
	subscriberAddress: {
		title: 'Subscriber Address',
		placeholder: 'E.g.:123 Oxford Valley Rd.',
	},
	subscriberDateOfBirth: {
		title: 'Subscriber Date of Birth',
		placeholder: MONTH_DATE_YEAR_SLASH_FORMAT,
		errorMessage: 'Subscriber date of birth is required',
	},
	relationshipToSubscriber: {
		title: "Patient's Relationship to Subscriber",
		placeholder: 'Select Relationship to Subscriber',
		errorMessage: 'Relationship to subscriber is required',
	},
	groupNumber: {
		title: 'Group Number',
		placeholder: 'E.g.: 12097657',
	},
	planName: {
		title: 'Plan Name',
		placeholder: 'E.g.: LocalPlus',
	},
	coverageStartDate: {
		title: 'Coverage Start Date',
		placeholder: MONTH_DATE_YEAR_SLASH_FORMAT,
	},
	coverageEndDate: {
		title: 'Coverage End Date',
		placeholder: MONTH_DATE_YEAR_SLASH_FORMAT,
	},
	guarantorName: {
		title: 'Guarantor Name',
		placeholder: 'E.g.: John Doe',
	},
	relationshipToGuarantor: {
		title: 'Relationship to Guarantor',
		placeholder: 'Select Relationship to Guarantor',
	},
	providerAcceptAssignment: {
		title: 'Provider Accept Assignment?',
		placeholder: 'Select',
	},
	assignmentOfBenefitAuthorized: {
		title: 'Assignment of Benefit Authorized?',
		placeholder: 'Select',
	},
	authorizationToReleaseMedicalInformation: {
		title: 'Authorization to Release Medical Info?',
		placeholder: 'Select',
	},
	remarks: {
		title: 'Remarks',
		placeholder: 'Enter Remarks',
	},
};

const AUTH_TO_RELEASE_MEDICAL_INFORMATION_OPTIONS = [
	{ label: 'Informed Consent', value: 'I' },
	{ label: 'Yes', value: 'Y' },
];

const BENEFIT_ASSIGNMENT_CERTIFICATION_OPTIONS = [
	{ label: 'Yes', value: 'Y' },
	{ label: 'No', value: 'N' },
	{ label: 'Not Applicable', value: 'W' },
];

const PROVIDER_ACCEPT_ASSIGNMENT_OPTIONS = [
	{ label: 'Yes', value: 'Y' },
	{ label: 'No', value: 'N' },
];

export {
	FIELDS_META,
	AUTH_TO_RELEASE_MEDICAL_INFORMATION_OPTIONS,
	BENEFIT_ASSIGNMENT_CERTIFICATION_OPTIONS,
	PROVIDER_ACCEPT_ASSIGNMENT_OPTIONS,
};
